angular.module('unica_archive_event.archive_event_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// EVENT
		.state('app.archive_event', {
			url: '/archive-event',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/archive-event/templates/archive-event.html',
					controller: 'ArchiveEventBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

		// EVENT YEARS
		.state('app.archive_event.years', {
			url: '/years',
			views: {
				'archiveEventContent': {
					templateUrl: './modules/archive-event/templates/years.html',
					controller: 'ArchiveEventYearsController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Archivio Eventi'
			}
		})


		// EVENT LIST AND DELETE
		.state('app.archive_event.list', {
			url: '/:year/list',
			views: {
				'archiveEventContent': {
					templateUrl: './modules/archive-event/templates/list.html',
					controller: 'ArchiveEventListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Archivio Eventi {{ year }}',
				parent: 'app.archive_event.years'
			}
		})


		// media_directory LIST AND DELETE
		.state('app.archive_event.directory_list', {
			url: '/:year/directory/:event_id',
			views: {
				'archiveEventContent': {
					templateUrl: './modules/archive-event/templates/directory-list.html',
					controller: 'ArchiveMediaDirectoryListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Lista Archivio Directory',
				parent: function($scope) {
					return 'app.archive_event.list';
				}
			}
		})


		// media_directory CREATE
		.state('app.archive_event.directory_create', {
			url: '/:year/directory/:event_id/create',
			views: {
				'archiveEventContent': {
					templateUrl: './modules/media-directory/templates/create.html',
					controller: 'ArchiveMediaDirectoryCreateController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Aggiungi Archivio Directory',
				parent: function($scope) {
					return 'app.archive_event.directory_list({year: ' + $scope.year + ', event_id:' + $scope.event_id + '})';
				}
			}
		})


		// media_directory EDIT
		.state('app.archive_event.directory_edit', {
			url: '/directory/:event_id/edit/:id',
			views: {
				'archiveEventContent': {
					templateUrl: './modules/media-directory/templates/edit.html',
					controller: 'ArchiveMediaDirectoryEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Archivio Directory',
				parent: function($scope) {
					return 'app.archive_event.directory_list({year: ' + $scope.year + ', event_id:' + $scope.event_id + '})';
				}
			}
		})


		// archive_media LIST
		.state('app.archive_event.media', {
			url: '/media/:event_id/:directory_id',
			views: {
				'archiveEventContent': {
					templateUrl: './modules/archive-media/templates/list.html',
					controller: 'ArchiveEventMediaListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Lista Archivio Media',
				parent: function($scope) {
					return 'app.archive_event.directory_list({year: ' + $scope.year + ', event_id:' + $scope.event_id + '})';
				}
			}
		});

});
